import { Route, Switch } from 'react-router-dom';
import MenuManager from '@yooink/youtils/es/MenuManager';
import PropTypes from 'prop-types';

import 'leaflet/dist/leaflet.css';
import 'react-contexify/dist/ReactContexify.css';
import '@yooink/youtils/es/FixLeafletIcons';
import './style.less';

import { BsBlockquoteRight } from 'react-icons/bs';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';
import { SiContentful } from 'react-icons/si';
import { useHistory } from 'react-router';
import { useSpotlightActions } from '../../AppSpotlight';
import { GiCakeSlice } from 'react-icons/gi';

MenuManager.RegisterGroup({
	key: 'content',
	name: 'Контент',
	icon: <SiContentful />,
	position: 6
}, []);

MenuManager.RegisterItem({
	parent: 'content',
	key: 'SitePages',
	path: '/sitepages',
	name: 'Страницы',
	icon: <BsBlockquoteRight />,
	acl: 'sitePages',
	position: 1
});

const SitePagesRoute = (props) => {
	const basePath = props.path || '/sitepages';
	const getPath = (path = '') => `${basePath}${path}`;
	const history = useHistory();
	useSpotlightActions([{
		id: 'pages.page',
		title: 'Страницы сайта',
		icon: <BsBlockquoteRight />,
		onTrigger: () => history.push(getPath()),
		special: true
	}]);

	const List = useLoadComponent(() => import('./List'), {
		basePath
	});
	const View = useLoadComponent(() => import('./PageEditor'), {
		basePath
	});
	const AdditionalScripts = useLoadComponent(() => import('./AdditionalScripts').then((m) => m.AdditionalScriptsSettings), {
		basePath
	});
	const HeaderSettings = useLoadComponent(() => import('./HeaderSettings').then((m) => m.HeaderSettings), {
		basePath
	});
	const SalesSettings = useLoadComponent(() => import('./PromoSettings').then((m) => m.SalesSettings), {
		basePath
	});
	const FooterSettings = useLoadComponent(() => import('./FooterSettings').then((m) => m.FooterSettings), {
		basePath
	});
	const MobileSettings = useLoadComponent(() => import('./MobileSettings').then((m) => m.MobileSettings), {
		basePath
	});

	const invoicePage = useLoadComponent(() => import('./Special/invoicePage').then((m) => m.InvoicePageSettings), {
		basePath
	});
	const referralPage = useLoadComponent(() => import('./Special/referralsPage').then((m) => m.ReferralsPageSettings), {
		basePath
	});
	const influencerPage = useLoadComponent(() => import('./Special/InfluencerPage').then((m) => m.InfluencerPageSettings), {
		basePath
	});
	const newsPage = useLoadComponent(() => import('./Special/newsPage').then((m) => m.NewsSettings), {
		basePath
	});
	const recipesPage = useLoadComponent(() => import('./Special/recipesPage').then((m) => m.RecipesSettings), {
		basePath
	});

	return (
		<>
			<Route
				exact
				path={getPath()}
				component={List}
			/>
			<Switch>
				<Route
					path={getPath('/special/recipes')}
					component={recipesPage}
				/>
				<Route
					path={getPath('/special/news')}
					component={newsPage}
				/>
				<Route
					path={getPath('/special/invoice')}
					component={invoicePage}
				/>
				<Route
					path={getPath('/special/referral')}
					component={referralPage}
				/>
				<Route
					path={getPath('/special/influencer')}
					component={influencerPage}
				/>
				<Route
					path={getPath('/additionalScripts')}
					component={AdditionalScripts}
				/>
				<Route
					exact
					path={getPath('/mobileSettings')}
					component={MobileSettings}
				/>
				<Route
					exact
					path={getPath('/footer')}
					component={FooterSettings}
				/>
				<Route
					exact
					path={getPath('/header')}
					component={HeaderSettings}
				/>
				<Route
					exact
					path={getPath('/sales')}
					component={SalesSettings}
				/>
				<Route
					exact
					path={getPath('/:id')}
					component={View}
				/>
			</Switch>
		</>
	);
};

SitePagesRoute.propTypes = {
	path: PropTypes.string
};

export { SitePagesRoute };
